// ATTENTION: Please keep this list camelcase and alphabetized.

var sysText = {
   

    // clean this up
    'whatIsThis': "<span>When you link your PayForward Prepaid Visa Debit Card<br /> to your bank account,  you will need to enter<br /> your bank routingnumber and account number. <br />The sample check presented on this page is an example <br />of where this informationshould appear on the checks<br /> issued from your bank. If you are not sure which numbers<br /> to enter, contact your bank to verify the correct information.</span>",
    'WhyIsIsImportant': "<span>When you available balance reaches the maximum balance that you can<br /> have on your PayForward Prepaid Visa Card (currently $10,000), any<br /> incoming transactions that would cause your balance to exceed the <br />maximum balance will be rejected. If this happens, all causes that are <br />connected to this Prepaid Card account would instantly not be able to <br />receive any funds from PayForward rebates or CashForward allocations <br />and transfers. <br /><br /> You can easily avoid this situation by selecting the option to Automatically <br />Transfer Funds from your Payforward Prepaid Visa Debit Card account <br />into your bank account when your available balance reaches the High <br />Balance Transfer Threshold amount that you select. <br /><br />You should also be aware that the Auto Upload to Bank Account feature is <br />subject to the same daily and monthly transaction limits that apply to <br />your PayForward Prepaid Visa Debit Card. We suggest that you select an <br />option that would result a minimum number of auto transfers, based on <br />the number and amount of transactions you anticipate will occure on your <br />card. You can review your card use limits and restrictions here:<br /><a id='whatIsThis' href='cardlimitations.html' target='new'>www.PayForward.com/CardLimits</a></span>",//we need real address
    'BalanceUnknown': "Balance information is not available at this time. Please try later.",

    
/* ==========================================================================
   General Headers ==========================================================
   ========================================================================== */
   'GH': {
        'accountHash':              'Account #',
        'accountNumber':            'Account Number',
        'activity':                 'Activity',
        'address1':                 'Address Line 1',
        'address2':                 'Address Line 2',
        'answer':                   'Answer',
        'balance':                  'Balance',
        'bankNickname':             'Bank Nickname',
        'cardNumber':               'Card Number',
        'category':                 'Category',
        'cause':                    'Cause',
        'causeAvatar':              'Cause Avatar',
        'causeName':                'Cause Name',
        'causes':                   'Causes',
        'city':                     'City',
        'comingSoon':               'Coming Soon',
        'coverPhoto':               'Cover Photo',
        'createNewCause':           'Create New Cause',
        'creditAmt':                'Credit Amount',
        'currentBalance':           'Current Balance',
        'date':                     'Date',
        'dob':                      'Date of Birth',
        'debitAmt':                 'Debit Amount',
        'description':              'Description',
        'discoverCauses':           'Discover Causes',
        'email':                    'Email',
        'endingBalance':            'Ending Balance',
        'firstName':                'First Name',
        'gender':                   'Gender',
        'haveQuestionsCheckOut':    'Have Questions? Make sure to check out:',
        'lastName':                 'Last Name',
        'managedBy':                'Managed by',
        'myAllocation':             'My Allocation',
        'myAllocations':            'My Allocations',
        'myZcards':                 'My Z Cards',
        'myCauses':                 'My Causes',
        'myContribution':           'My Contribution',
        'myPFPPDC':                 'My PayForward Account',
        'myRebateAlloc':            'My Cash Back Allocation',
        'userRebateAlloc':          'Their Cash Back Allocation',
        'myWallet':                 'My Wallet',
        'name':                     'Name',
        'participant':              'Participant',
        'participants':             'Participants',
        'password':                 'Password',
        'phone':                    'Phone',
        'privacy':                  'Privacy',
        'question':                 'Question',
        'raisedByYouThisYear':      'Raised by Me this Year',
        'raisedByOthersThisYear':   'Raised by Others this Year',
        'rebate':                   'Rebate',
        'reEnterEmail':             'Re-enter Email',
        'reEnterPassword':          'Re-enter Password',
        'routingNumber':            'Routing Number',
        'signUpforPF':              'Sign Up for PayForward',
        'ssn':                      'Social Security Number',
        'ssn4':                     'Last 4 of Social Security Number',
        'startingBalance':          'Starting Balance',
        'state':                    'State',
        'tagline':                  'Tagline',
        'totalRaised':              'Total Raised',
        'transHistory':             'Transaction History',
        'type':                     'Type',
        'url':                      'URL',
        'zipCode':                  'Zip Code',
        'wallet':                   'Wallet',
        'referralCode':             'Promo code',
        'referralCodeOptional':     'Optional',
        'ytdRebatesFromPurchases':  'YTD cash back from purchases',
        'ytdRebatesFromMembers':    'YTD cash back allocations from other members',
        'ytdTransfersToOtherAccounts': 'YTD Transfers to others',
        'ytdTransfersFromOthers': 'YTD Transfers from others',

   },

/* ==========================================================================
   General Text =============================================================
   ========================================================================== */
   'GT': {
        'avatarImgSpec':        'JPG, PNG or GIF.  Should be square & below 5MB.',
        'coverPhotoImgSpec':    'JPG, PNG or GIF.  Should be below 5MB.',
        'fileTypeNotSupported': 'This file type is not supported.',
        'indicatesRequired':    'Indicates required field.',
        'to':                   'to',
        'passwordSpec':         'Minimum 8 characters including one uppercase, one lowercase, and one number.',
        'pfDotComSlash':        'www.payforward.com/#'
   },

/* ==========================================================================
   Action Label =============================================================
   ========================================================================== */
   'AL': {
        'allocate':             'Allocate',
        'addMoney':             'Add Money',
        'cancel':               'Cancel',
        'chooseImage':          'Choose an image',
        'confirm':              'Confirm',
        'continue':             'Continue',
        'createCause':          'Create Cause',
        'delete':               'Delete',
        'edit':                 'Edit',
        'editBankInfo':         'Edit Bank Account Information',
        'getTheCard':           'Get the Card',
        'go':                   'Go',
        'howItWorks':           'How It Works',
        'invite':               'Invite',
        'learnMore':            'Learn More',
        'linkMyAccount':        'Link My Account',
        'login':                'Log in',
        'moreWaysToAddMoney':   'More Ways to Add Money',
        'noThanksMaybeLater':   'No Thanks, maybe later',
        'noThanksSetUpLater':   'No thanks, I\'ll set this up later',
        'printForm':            'Print Form',
        'questionsAndAnswers':  'Questions & Answers',
        'removeImage':          'Remove image',
        'save':                 'Save',
        'selectChoose':         '-- choose one --',
        'setUpNow':             'Set Up Now',
        'signUp':               'Sign Up',
        'submitApplication':    'Submit Application',
        'transfer':             'Transfer',
        'transferMoney':        'Transfer Money',
        'update':               'Update',
        'viewDetails':          'View Details',
        'withdrawMoney':        'Withdraw Money'
   },

/* ==========================================================================
   Form Label ===============================================================
   ========================================================================== */
   'FL': {
        'show':                 'Show',
        'from':                 'From',
        'fromYourConnections':  'From Your Connections',
        'to':                   'To',
        'viaEmail':             'Via Email (separate by comma)',
   },

/* ==========================================================================
   FORM VALIDATION ==============================================================
   ========================================================================== */
    'FV': {
        'required': {
            'acceptTerms':          'You must accept the terms to continue.',
            'accountNumber':        'Account number is required.',
            'address':              'Please enter an address.',
            'ammount':              'Amount is required.',
            'autoTransferAmt':      'Amount to Auto Transfer to Your Prepaid Debit Card is required.',
            'bankName':             'Bank Name is required.',
            'causeCategory':        'Please choose a cause category.',
            'causeName':            'Please enter a cause name.',
            'causeSelect':          'Please select a cause.',
            'causeType':            'Please select a cause type.',
            'causeURL':             'Please enter a cause home page URL.',
            'city':                 'Please enter a city.',
            'dob':                  'Please enter your date of birth',
            'email':                'Please enter an email address.',
            'emailInvite':          'Email address required for invitation.',
            'firstName':            'Please enter a first name.',
            'gender':               'Please select a gender.',
            'lastName':             'Please enter a last name.',
            'lowBalanceThrethold':  'Low Balance Threshold is required.',
            'merchantName':         'Please enter the Merchant or Organization name and city/state to send request.',
            'message':              'Please enter a message.',
            'name':                 'Please enter your name.',
            'password':             'Please enter a password.',
            'passwordCurrent':      'Please enter your current password and try again.',
            'passwordReenter':      'Please re-enter your password.',
            'phoneNumber':          'Please enter a phone number.',
            'routingNumber':        'Routing Number is required.',
            'securityAnswer':       'Please enter an answer to the question above.',
            'securityQuestion':     'Please select a security question.',
            'ssnTaxID':             'Please enter the social security number',
            'ssn4':                 'Please enter the last 4 digits of your SSN',
            'state':                'Please choose a state.',
            'value':                'Please enter a value.',
            'zipCode':              'Please enter a zip code.',
            'eventstart':           'Please enter an event start date.',
            'eventend':             'Please enter an event end date.',
            'ACHserviceType':       'Service Type is required.',
            'isAnthemMember':       'Please select yes or no.'

        },
        'invalid': {
            'accountNumber':        'Please enter a valid account number.',
            'ammount':              'Amount entered is invalid.',
            'autoTransferAmt':      'Amount to transfer should be greater than the balance',
            'balanceNotZero':       'Balance cannot be zero',
            'cardLoadMinAmt':       'Minimum amount $',
            'cardLoadMaxAmt':       'Maximum amount $',
            'cardUnloadMinAmt':     'Minimum amount $',
            'cardUnloadMaxAmt':     'Maximum amount $',
            'causeTransferMaxAmt':  'Amount must not exceed $',
            'causeTransferMinAmt':  'Amount must be a minimum of $',
            'causeURL':             'Please choose a different cause home Page URL.',
            'causeURLChars':        'Cause URL special characters may only include period (.), underscore (_), or dash (-).',
            'dob':                  'Should be at least 18 or older',
            'dobzcard':             'Should be at least 10 or older',
            'email':                'Please enter a valid email address.',
            'emailExists':          'This email address is already associated with another account.',
            'emailsDoNotMatch':     'Please make sure email addresses match.',
            'fromTo':               'From and To fields cannot be the same.',
            'insufficientFunds':    'Insufficient funds',
            'lowBalanceAmt':        'Balance must be less than the amount to transfer.',
            'password':             'Password should be minimum 8 characters including one uppercase, one lowercase, and one number',
            'passwordsDoNotMatch':  'Passwords do not match.',
            'phoneNumber':          'Please enter a valid phone number.',
            'promoCode':            'Invalid invite code.',
            'routingNumber':        'Please enter a valid routing number.',
            'ssnTaxID':             'Please provide a valid social security number',
            'ssn4':                 'Please provide valid last 4 digits of your SSN',
            'transferAmtTooHigh':   'The transfer amount cannot exceed your current balance. Please enter a smaller amount.',
            'transferSelection':    'Invalid selections for transfer. Please modify you selections and try again.',
            'value':                'Please enter a valid value',
            'zipCode':              'Invalid zip code.',
            'invalideventdates':    'Invalid event dates',
			'amount': 				'Enter an amount',
			'amountInvalid':        'Enter valid amount'
        }
    },

/* ==========================================================================
   Image Alt ================================================================
   ========================================================================== */
   'IA': {
        'PFPPDC':     'PayForward Prepaid Debit Card',
   },

/* ==========================================================================
   Page Specific ============================================================
   ========================================================================== */
    'PS': {
        'inviteToCause': {
            'header':       'Invite to Cause',
            'explain':      'Choose from your connections or enter email addresses below to invite people to the cause.'
        },
        'inviteToPayforward': {
            'header':       'Invite to Payforward',
            'explain':      'Enter email addresses separate by comma below to invite people to Payforward.'
        },
        'createEditCause': {
            'pageHeader1Main':      'Let\'s get your cause set up & funded!',
            'pageHeader1Sub':       'Causes are a great way to raise money and awareness for what’s important to you.<br />You can create a cause for just about anything in three easy steps!',
            'pageHeader2Main':      'Edit Your Cause',
            'pageHeader2Sub':       'Keep your cause up to date with new information and images.  If you are making any significant changes, you may want to update your cause participants.',
            'form1Header':          '1. Basic Details',
            'form1Explain':         'Introduce your cause to the world. Make a good first impression.',
            'form2Header':          '2. Info Page',
            'form2Explain':         'This is where the world really gets to know your cause. A compelling cover photo and detailed description can go a long way to helping new visitors connect with your cause.',
            'form3Header':          '3. Settings',
            'form3Explain':         'Set up your cause just the way you like it.',
            'formHelp1':            'Choose a name for your cause that members will remember. This name is how they will find your cause in a PayForward search. (40 character limit)',
            'formHelp2':            'A small image to represent your cause throughout PayForward.',
            'formHelp3':            'A short blurb about your cause that sums it all up. This will appear on your cause card (right) and in any search results. (100 character limit)',
            'formHelp4':            'This helps local members find and support you. It also helps to tell the difference between causes with similar names.',
            'formHelp5':            'Choose a nice big image to add some personality to your cause landing page. Don’t feel like doing this now?  You can always add one later.',
            'formHelp6':            'The full description of your cause with all the details you want the world to know. Write as much or as little as you want!',
            'formHelp7':            'This is the url that anyone can use to directly visit your cause home page on PayForward. Login/Registration may be required. NOTE: This url is not case sensitive. Spaces between words and some special characters are not allowed.',
            'formHelp8':            'This cause will not appear in search results or in the “Discover Causes” section. You will have to invite people to join the cause.',
            'formHelp9':            'All new members requesting to join this cause will need to be individually approved by the cause manager. This can be used for both private  and public causes.',
            'formHelp10':           'This allows for any cause-related financial transactions (such as transfers to and from the cause, as well as rebate allocations) to be viewed by anyone who has joined the cause. Sensitive financial information (account numbers, card numbers, etc.) will remain confidential, of course.',
            'previewHelp1':         'This is a preview of your cause card. Other members will see this in search results and in the “Discover Causes” section.',
            'previewHelp2':         'This cover photo and your description will be displayed on the info landing page for members visiting your cause.',
            'previewHelp3':         'As the manager of the Cause, you can adjust your settings at any time by visiting “Edit Cause” on your cause home page.',
            'privacyOption1':       'Cause is private',
            'privacyOption2':       'Joining cause requires approval',
            'privacyOption3':       'Show cause transaction history to participants',
            'getCardExplainP1':     'Causes are a great way to raise funds and awareness for what’s important to you. To create a cause and receive rebates and allocations for that cause, you’ll need to get a PayForward<sup><small>&#174</small></sup> Prepaid Visa<sup><small>&#174</small></sup> Debit Card.',
            'getCardExplainP2':     'It only takes a few minutes and there is no charge to obtain the card, add or transfer funds, or make purchases in the U.S.'
        },
        'financialBenefits': {
            'header':       'Start Earning and Funding!',
            'headerSub':    'To enjoy the full financial benefits, get the PayForward<sup><small>&#174</small></sup> Prepaid Visa<sup><small>&#174</small></sup> Debit Card.',
            'explainP1':    'Start earning Instant Rebates up to 15% on all your purchases with our merchants and use those rebates to fund your own causes and support others, at no cost to you or them.',
            'bullet1':      'No credit check or issuance fees',
            'bullet2':      'No annual or monthly fees',
            'bullet3':      'No fees to load or transfer funds',
            'bullet4':      'No fees to make purchases in the U.S.',
            'bullet5':      'No hassles - automated card reload option',
            'explainP3':    'The PayForward Prepaid Card can be used anywhere VISA debit cards are accepted.'
        },
        'invitationLanding': {
            'explainP1':    'You have been invited to join the cause "',
            'explainP2':    ' on PayForward.<br />Sign up for free below or log in to view the cause page.',
            'explainP3':    'You have been invited to join PayForward.<br />Sign up for free below.'
        },
        'registration': {
            'cardSignUp': {
                'form1Header':      'Personal Details',
                'form2Header':      'Security Questions',
                'form3Header':      'Cardholder Agreement',
                'genderOption1':    'Male',
                'genderOption2':    'Female',
                'genderOption3':    'Decline to answer'
            },
            'confirmEmail': {
                'header':       'Confirm Your Email Address',
                'explainP1':    'An email has been sent to',
                'explainP2':    'with a confirmation code.<br />Please enter the code below to complete Sign Up.',
                'resendEmail':  'Resend Confirmation Email'
            },
            'signUp': {
                'emailMeNews':      'Email me PayForward news and updates',
                'alreadyHaveAcct':  'Already have an account?'
            }
        },
        'settings': {
            'fundingOptions': {
                'header1':             'Link Your Bank Account',
                'header2':             'Verify Your Bank Account',
                'explain1':            'Link your bank account so you can transfer money to and from your PayForward account. After adding your account information here, we will make two small deposits into that bank account to verify it.<br /><br />Our trial deposits should arrive within <strong>2-3 business days</strong>.',
                'explain2':            'Please check that your information is correct.',
                'formExplain1':        'Your choice - to help you identify the account',
                'formExplain2':        'First nine digits on the bottom left of a check',
                'formExplain3':        'Four to thirteen digit group after routing number',
                'veriFailHeader':      'Verification Failed',
                'veriFailBody':        'The amounts entered do not match our records.  Please try again.',
                'veriFailMaxBody':     'You have entered an incorrect amount the maximum number of times. The bank account is now blocked as a funding source for your PayForward Card.<br /><br />Please add a different account or contact Member Services for assistance.<br /><br />PayForward Member Services:<br />Phone: 844-904-9273<br />Email: support@payforward.com'
            }
        },
        'siteDown': {
            'header':       'The PayForward website is temporarily unavailable',
            'explain':      'We\'ll be back soon. Don\'t worry, you can still use your card & earn rebates. You can also visit our social media sites for more info.',
            'thanks':       'Thanks!'
        },
        'transHistory': {
            'showingFrom':     'Showing transactions from'
        },
        'waysToAddMoney': {
            'header':           'Ways to Add Money to Your PayForward Account',
            'option1Title':     'Link Your Bank Account',
            'option1Desc':      'Linking your bank account makes it convenient to add and manage money for your PayForward account. Automatic money loading and transfer options make it even easier!',
            'option2Title':     'Direct Deposit',
            'option2Desc':      'Add money right to your PayForward account with each paycheck. Add it all, or just a part. The choice is yours. Fill out the form and submit it to your employer or benefits office. It’s that simple.'
        }
    },

/* ==========================================================================
   Symbols ==================================================================
   ========================================================================== */
    'SB': {
        'copy':     '&#169;',
        'r':        '&#174;',
        'tm':       '&#8482;'
    }
};

define("models/shared/lookups/systext", function(){});

